import anime from 'animejs'

export default ({ app, store }, inject) => {
  inject('scrollToTop', (elemId, smooth, paddingTop) => {
    const scrollTo = document.getElementById(elemId)
    if (scrollTo) {
      const top = scrollTo.getBoundingClientRect().top + pageYOffset - paddingTop
      anime({
        targets: window.document.scrollingElement || window.document.body || window.document.documentElement,
        scrollTop: top,
        duration: smooth,
        easing: 'easeInOutQuad'
      })
    } else {
      return false
    }
  })
}
